import React, { useState, useEffect, useMemo } from 'react'
import './Layout.css'
import { useHistory } from 'react-router-dom'
import { NavLink } from 'react-router-dom'
import jwtDecode from 'jwt-decode'
import Notification from '../notification/Notification'
//MUI
import Button from '@material-ui/core/Button'
import MenuItem from '@material-ui/core/MenuItem'
import Menu from '@material-ui/core/Menu'
import Badge from '@material-ui/core/Badge'
import IconButton from '@material-ui/core/IconButton'
import NotificationsIcon from '@material-ui/icons/Notifications'
import NoteAddIcon from '@material-ui/icons/NoteAdd'
// import SearchIcon from '@material-ui/icons/Search'
//Redux
import { signOut, getPendingDocuments, getNotifications, getUserData, changeDropdownOption } from '../../redux'
import { useDispatch, useSelector } from 'react-redux'
//Util
import MyTooltip from '../../utilities/tooltip/MyTooltip'
import Spinner, { SmallSpinner } from '../../utilities/spinner/Spinner'

function Header() {
  const token = localStorage.FBIdToken

  const history = useHistory()
  const dispatch = useDispatch()
  const user = useSelector((state) => state.user)
  const ui = useSelector((state) => state.ui)
  const notifications = useSelector((state) => state.notifications)

  const [notificationAnchorEl, setNotificationAnchorEl] = useState(null)
  const [profileAnchorEl, setProfileAnchorEl] = useState(null)

  const handleNotificationClick = (event) => {
    setNotificationAnchorEl(event.currentTarget)
  }
  const handleNotificationClose = () => {
    setNotificationAnchorEl(null)
  }

  const handleProfileClick = (event) => {
    setProfileAnchorEl(event.currentTarget)
  }
  const handleProfileClose = () => {
    setProfileAnchorEl(null)
  }

  const onMyAccountClick = () => {
    history.push('/viewProfile')
    handleProfileClose()
  }

  const onLogOut = () => {
    dispatch(changeDropdownOption(1))
    dispatch(signOut())
  }

  const menuItemStyle = useMemo(() => {
    return {
      padding: 0,
      margin: 0,
      backgroundColor: 'white',
    }
  }, [])

  useEffect(() => {
    if (user.credentials.id) {
      dispatch(getPendingDocuments('Pending'))
      let unsubscribe = () => {}
      dispatch(
        getNotifications((func) => {
          unsubscribe = func
        })
      )
      return () => {
        unsubscribe()
      }
    } else if (token) {
      const decodedToken = jwtDecode(token)
      dispatch(getUserData(decodedToken.user_id))
    }
  }, [user.credentials.id])

  let profileMarkup =
    user.loading || !user.credentials.image || !user.credentials.image.url ? (
      <Spinner />
    ) : (
      <img src={user.credentials.image.url} alt='profile' className='header-profile-image' />
    )

  return (
    <nav className='header'>
      <ul className='header-nav'>
        <li className='header-item '>
          <h4>{ui.title}</h4>
        </li>

        <li className='header-item'>
          <NavLink to='/createDocumentForm'>
            <MyTooltip tips='Create Document'>
              <IconButton style={{ outline: 'none ' }}>
                <NoteAddIcon fontSize='large' />
              </IconButton>
            </MyTooltip>
          </NavLink>
        </li>

        <li className='header-item'>
          <MyTooltip tips='Notification'>
            <IconButton
              style={{ outline: 'none' }}
              className={`${notificationAnchorEl ? 'notification-iconButton' : ''}`}
              onClick={handleNotificationClick}
            >
              <Badge badgeContent={notifications.notifications.length} color='secondary' defaultValue>
                <NotificationsIcon fontSize='large' />
              </Badge>
            </IconButton>
          </MyTooltip>

          <Menu
            id='simple-menu'
            anchorEl={notificationAnchorEl}
            keepMounted
            open={Boolean(notificationAnchorEl)}
            onClose={handleNotificationClose}
            getContentAnchorEl={null}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
            PaperProps={{
              style: {
                maxHeight: '50vh',
                padding: 0,
                margin: 0,
                backgroundColor: 'black',
              },
            }}
          >
            {notifications.notifications.length > 0 ? (
              notifications.notifications.map((notification) => {
                return (
                  <MenuItem style={menuItemStyle} key={notification.id}>
                    <Notification
                      notification={notification}
                      handleNotificationClose={handleNotificationClose}
                      userId={user.credentials.id}
                    />
                  </MenuItem>
                )
              })
            ) : (
              <MenuItem style={menuItemStyle} onClick={handleNotificationClose}>
                <Notification />
              </MenuItem>
            )}
          </Menu>
        </li>

        {/* Icons made by <a href="https://www.flaticon.com/authors/freepik" title="Freepik">Freepik</a> from <a href="https://www.flaticon.com/" title="Flaticon"> www.flaticon.com</a> */}
        <li className='header-item '>
          <div className='header-profile'>{profileMarkup}</div>

          <Button onClick={handleProfileClick} style={{ outline: 'none ' }}>
            <div style={{ textAlign: 'center' }}>
              <p style={{ margin: 0 }}>{user.credentials.role}</p>
              <p style={{ margin: 0 }}>{user.credentials.initial}</p>
            </div>
          </Button>
          <Menu
            id='simple-menu'
            anchorEl={profileAnchorEl}
            keepMounted
            open={Boolean(profileAnchorEl)}
            onClose={handleProfileClose}
            getContentAnchorEl={null}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            <MenuItem onClick={onMyAccountClick}>My account</MenuItem>
            <MenuItem onClick={onLogOut} disabled={ui.loading}>
              <div>
                <div>
                  Logout
                  {ui.loading && <SmallSpinner />}
                </div>
              </div>
            </MenuItem>
          </Menu>
        </li>
      </ul>
    </nav>
  )
}

export default Header
